import {
  IRegisterParams,
  ILoginParams,
  ISendEmailCodeParams,
  ISendSMSCodeParams,
  IResetPasswordParams,
  IFacSocialLoginParams,
  ISocialLoginParams,
  ISocialAuthRedirectParams,
  IRefreshTokenParams,
} from "~/types/account";

// 注册; +
export const register = (params: IRegisterParams) =>
  usePost("/api/v1/model-user-server/auth/register", params);

// 使用账号密码登录; +
export const login = (params: ILoginParams) =>
  usePost("/api/v1/model-user-server/auth/login", params);

// 使用手机验证码登录; +
export const smsLogin = (params: ILoginParams) =>
  usePost("/api/v1/model-user-server/auth/sms-login", params);

// 发送邮箱验证码; +
export const sendEmailCode = (params: ISendEmailCodeParams) =>
  usePost("/api/v1/model-user-server/auth/send-email-code", params);

// 发送手机验证码; +
export const sendSmsCode = (params: ISendSMSCodeParams) =>
  usePost("/api/v1/model-user-server/auth/send-sms-code", params);

// 重置密码; +
export const resetPassword = (params: IResetPasswordParams) =>
  usePut("/api/v1/model-user-server/auth/reset-password", params);

// fac三方登录, 使用token; +
export const facSocialLogin = (params: IFacSocialLoginParams) =>
  usePost("/api/v1/model-user-server/auth/fac-social-login", params);

// 社交快捷登录(wechat), 使用code授权码;
export const socialLogin = (params: ISocialLoginParams) =>
  usePost("/api/v1/model-user-server/auth/social-login", params);

// 社交授权的跳转(wechat);
export const socialAuthRedirect = (params: ISocialAuthRedirectParams) =>
  useGet("/api/v1/model-user-server/auth/social-auth-redirect", params);

// 退出登录; +
export const logout = () => usePost("/api/v1/model-user-server/auth/logout");

// 刷新令牌token;
export const refreshToken = (params: IRefreshTokenParams) =>
  usePost("/api/v1/model-user-server/auth/refresh-token", params);
